import { StyleSheet } from "react-native";

import { APP_TOKENS as tokens } from "../../../../styles/tokens";
import { IMAGE_TOOLS_TOKENS as imageToolsTokens } from "./tokens";

export const styles = StyleSheet.create({
  page: {
    flex: 1,
    backgroundColor: tokens.color.background,
  },
  pageContent: {
    flexGrow: 1,
    alignItems: "center",
    paddingBottom: tokens.spacing.giant,
  },
  contentContainer: {
    width: "100%",
    maxWidth: imageToolsTokens.size.contentMaxWidth,
    gap: tokens.spacing.xxl,
  },
  header: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: tokens.spacing.lg,
    paddingVertical: tokens.spacing.md,
  },
  mobileHeader: {
    flexDirection: "column",
  },
  headerIcon: {
    width: tokens.spacing.massive,
    height: tokens.spacing.massive,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceAccent,
    alignItems: "center",
    justifyContent: "center",
  },
  headerCopy: {
    flex: 1,
    minWidth: 0,
    gap: tokens.spacing.xs,
  },
  eyebrow: {
    color: tokens.color.accentDark,
    fontFamily: tokens.font.bold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
    letterSpacing: tokens.letterSpacing.caps,
  },
  pageTitle: {
    flexShrink: 1,
  },
  pageDescription: {
    flexShrink: 1,
    maxWidth: imageToolsTokens.size.contentMaxWidth,
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
  },
  filterOptionsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacing.lg,
  },
  filterOption: {
    position: "relative",
    width: imageToolsTokens.size.filterOptionDesktop,
    height: imageToolsTokens.size.filterOptionDesktop,
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacing.sm,
    padding: tokens.spacing.sm,
    borderWidth: tokens.borderWidth.strong,
    borderColor: tokens.color.borderStrong,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.surface,
  },
  mobileFilterOption: {
    width: imageToolsTokens.size.filterOptionMobile,
    height: imageToolsTokens.size.filterOptionMobile,
    gap: tokens.spacing.xs,
    padding: tokens.spacing.xs,
    borderWidth: tokens.borderWidth.thin,
  },
  filterOptionSelected: {
    borderColor: tokens.color.accent,
    backgroundColor: tokens.color.surfaceAccent,
  },
  filterOptionHovered: {
    borderColor: tokens.color.accentDark,
  },
  filterOptionPressed: {
    transform: [{ scale: imageToolsTokens.motion.pressScale }],
  },
  filterOptionUnavailable: {
    backgroundColor: tokens.color.surfaceMuted,
  },
  filterOptionIcon: {
    width: imageToolsTokens.size.filterIconDesktop,
    height: imageToolsTokens.size.filterIconDesktop,
    alignItems: "center",
    justifyContent: "center",
  },
  mobileFilterOptionIcon: {
    width: imageToolsTokens.size.filterIconMobile,
    height: imageToolsTokens.size.filterIconMobile,
  },
  filterOptionText: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.medium,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.xs,
    textAlign: "center",
  },
  mobileFilterText: {
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  comingSoonBadge: {
    position: "absolute",
    top: imageToolsTokens.size.comingSoonOffset,
    right: imageToolsTokens.size.comingSoonOffset,
    zIndex: tokens.zIndex.above,
    paddingHorizontal: tokens.spacing.sm,
    paddingVertical: tokens.spacing.xs,
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.textPrimary,
  },
  comingSoonBadgeText: {
    color: tokens.color.inverse,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  toolCard: {
    width: "100%",
    padding: tokens.spacing.xxl,
    gap: tokens.spacing.xl,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.xl,
    backgroundColor: tokens.color.surface,
    ...tokens.shadow.card,
  },
  debugPanel: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.spacing.xxl,
    padding: tokens.spacing.xxl,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.accentMuted,
    borderRadius: tokens.radius.xl,
    backgroundColor: tokens.color.surfaceAccent,
  },
  debugPanelCopy: {
    flex: 1,
    minWidth: 0,
    alignItems: "flex-start",
    gap: tokens.spacing.sm,
  },
  debugBadge: {
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.textPrimary,
  },
  debugBadgeText: {
    color: tokens.color.inverse,
    fontFamily: tokens.font.bold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
    letterSpacing: tokens.letterSpacing.caps,
  },
  debugStatus: {
    minHeight: imageToolsTokens.size.iconButton,
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.sm,
  },
  debugActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.md,
  },
  sectionHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: tokens.spacing.md,
  },
  stepBadge: {
    width: tokens.spacing.xxxl,
    height: tokens.spacing.xxxl,
    borderRadius: tokens.radius.round,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.color.surfaceAccent,
  },
  stepBadgeText: {
    color: tokens.color.accentDark,
    fontFamily: tokens.font.bold,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  sectionHeaderCopy: {
    flex: 1,
    minWidth: 0,
    gap: tokens.spacing.xs,
  },
  sectionTitle: {
    flexShrink: 1,
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xl,
    lineHeight: tokens.lineHeight.xl,
  },
  sectionDescription: {
    flexShrink: 1,
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  mobileCard: {
    maxWidth: "100%",
    flexBasis: "100%",
  },
  pressed: {
    opacity: tokens.opacity.pressed,
    backgroundColor: tokens.color.surfaceMuted,
  },
  divider: {
    width: "100%",
    height: tokens.borderWidth.thin,
    backgroundColor: tokens.color.border,
    marginVertical: tokens.spacing.xs,
  },
  faceModeSection: {
    width: "100%",
    gap: tokens.spacing.md,
    padding: tokens.spacing.lg,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  faceModeOptions: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: tokens.spacing.md,
  },
  faceModeOption: {
    minWidth: imageToolsTokens.size.actionMinWidth,
    minHeight: imageToolsTokens.size.iconButton,
    flexGrow: 1,
    flexBasis: imageToolsTokens.size.actionMinWidth,
    gap: tokens.spacing.xs,
    padding: tokens.spacing.md,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.borderStrong,
    borderRadius: tokens.radius.button,
    backgroundColor: tokens.color.surface,
  },
  faceModeOptionSelected: {
    borderWidth: tokens.borderWidth.strong,
    borderColor: tokens.color.accent,
    backgroundColor: tokens.color.surfaceAccent,
  },
  faceModeOptionText: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
  },
  faceModeOptionDescription: {
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  coverGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: tokens.spacing.md,
  },
  coverOptionWrapper: {
    position: "relative",
    minWidth: imageToolsTokens.size.gridMinWidth,
    flex: 1,
  },
  coverOption: {
    width: "100%",
    minHeight: tokens.spacing.massive + tokens.spacing.massive,
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.md,
    padding: tokens.spacing.md,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surface,
  },
  stickerLibraryToolbar: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.spacing.lg,
  },
  stickerLibraryCopy: {
    flex: 1,
    minWidth: 0,
    gap: tokens.spacing.xs,
  },
  stickerLibraryTitle: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
  },
  hiddenInput: {
    display: "none",
  },
  libraryLoading: {
    minHeight: tokens.spacing.massive,
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.sm,
  },
  deleteStickerButton: {
    position: "absolute",
    top: tokens.spacing.xs,
    right: tokens.spacing.xs,
    zIndex: tokens.zIndex.above,
    width: imageToolsTokens.size.iconButton,
    height: imageToolsTokens.size.iconButton,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.overlay,
  },
  deleteStickerButtonHovered: {
    backgroundColor: tokens.color.textPrimary,
  },
  coverOptionSelected: {
    borderWidth: tokens.borderWidth.strong,
    borderColor: tokens.color.accent,
    backgroundColor: tokens.color.surfaceAccent,
  },
  coverOptionWithDelete: {
    paddingRight: tokens.spacing.giant + tokens.spacing.sm,
  },
  coverPreviewContainer: {
    width: imageToolsTokens.size.coverPreview,
    height: imageToolsTokens.size.coverPreview,
    padding: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.surfaceMuted,
  },
  coverPreview: {
    width: "100%",
    height: "100%",
  },
  coverLabel: {
    flex: 1,
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  radioOuter: {
    width: tokens.spacing.xxl,
    height: tokens.spacing.xxl,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: tokens.radius.round,
    borderWidth: tokens.borderWidth.strong,
    borderColor: tokens.color.borderStrong,
  },
  radioOuterSelected: {
    borderColor: tokens.color.accent,
  },
  customStickerRadio: {
    position: "absolute",
    right: tokens.spacing.md,
    bottom: tokens.spacing.md,
  },
  radioInner: {
    width: tokens.spacing.md,
    height: tokens.spacing.md,
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.accent,
  },
  interactiveHover: {
    borderColor: tokens.color.accentDark,
  },
  focused: {
    outlineStyle: "solid",
    outlineColor: tokens.color.accentDark,
    outlineWidth: tokens.borderWidth.strong,
    outlineOffset: tokens.borderWidth.strong,
  } as any,
  disabled: {
    opacity: tokens.opacity.disabled,
  },
  errorBanner: {
    padding: tokens.spacing.md,
    alignItems: "flex-start",
    gap: tokens.spacing.md,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.errorBorder,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.errorSurface,
  },
  errorText: {
    color: tokens.color.errorText,
    fontFamily: tokens.font.medium,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  retryButton: {
    minWidth: imageToolsTokens.size.actionMinWidth,
  },
  dialogBackdrop: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacing.xl,
    backgroundColor: tokens.color.overlay,
  },
  dialog: {
    width: "100%",
    maxWidth: imageToolsTokens.size.dialogMaxWidth,
    alignItems: "center",
    gap: tokens.spacing.lg,
    padding: tokens.spacing.xxl,
    borderRadius: tokens.radius.xl,
    backgroundColor: tokens.color.surface,
    ...tokens.shadow.card,
  },
  dialogTitle: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.bold,
    fontSize: tokens.fontSize.xl,
    lineHeight: tokens.lineHeight.xl,
    textAlign: "center",
  },
  dialogPreview: {
    width: tokens.spacing.giant + tokens.spacing.xxxl,
    height: tokens.spacing.giant + tokens.spacing.xxxl,
    padding: tokens.spacing.sm,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  dialogActions: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: tokens.spacing.md,
  },
  deleteAction: {
    borderColor: tokens.color.errorText,
    backgroundColor: tokens.color.errorText,
  },
  deleteActionText: {
    color: tokens.color.inverse,
  },
  progressPanel: {
    padding: tokens.spacing.lg,
    gap: tokens.spacing.md,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceAccent,
  },
  progressCopyRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.sm,
  },
  progressText: {
    flex: 1,
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  progressTrack: {
    width: "100%",
    height: imageToolsTokens.size.progressHeight,
    overflow: "hidden",
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.accentMuted,
  },
  progressFill: {
    height: "100%",
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.accent,
  },
  progressHint: {
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  actions: {
    alignItems: "flex-end",
  },
  mobileActions: {
    width: "100%",
    alignItems: "stretch",
  },
  mobileDialogActions: {
    flexDirection: "column",
    alignItems: "stretch",
  },
  primaryAction: {
    minWidth: imageToolsTokens.size.actionMinWidth,
  },
  compactButton: {
    minWidth: imageToolsTokens.size.actionMinWidth,
  },
  resultsCard: {
    width: "100%",
    padding: tokens.spacing.xxl,
    gap: tokens.spacing.xxl,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.xl,
    backgroundColor: tokens.color.surface,
    ...tokens.shadow.card,
  },
  resultsHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: tokens.spacing.xxl,
  },
  mobileStack: {
    flexDirection: "column",
  },
  resultsHeaderCopy: {
    flex: 1,
    alignItems: "flex-start",
    gap: tokens.spacing.sm,
  },
  successBadge: {
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.successBorder,
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.successSurface,
  },
  successBadgeText: {
    color: tokens.color.successText,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  reviewBadge: {
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.errorBorder,
    borderRadius: tokens.radius.round,
    backgroundColor: tokens.color.errorSurface,
  },
  reviewBadgeText: {
    color: tokens.color.errorText,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  resultsTitle: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.bold,
    fontSize: tokens.fontSize.xxl,
    lineHeight: tokens.lineHeight.xxl,
  },
  resultActions: {
    alignItems: "flex-end",
  },
  resultsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: tokens.spacing.lg,
  },
  resultCard: {
    flexGrow: 1,
    flexBasis: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surface,
  },
  editorStack: {
    width: "100%",
    gap: tokens.spacing.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  censorshipEditorItem: {
    position: "relative",
    width: "100%",
    padding: tokens.spacing.md,
    paddingTop: tokens.spacing.huge,
    backgroundColor: tokens.color.surface,
  },
  filteredImageContainer: {
    position: "relative",
    width: "100%",
    height: imageToolsTokens.size.editorMaxHeight,
    padding: tokens.spacing.md,
    paddingTop: tokens.spacing.huge,
    backgroundColor: tokens.color.surfaceMuted,
  },
  filteredImage: {
    width: "100%",
    height: "100%",
  },
  mobileFilteredImageContainer: {
    height: imageToolsTokens.size.previewHeight * 2,
  },
  imageLabel: {
    position: "absolute",
    top: tokens.spacing.sm,
    left: tokens.spacing.sm,
    zIndex: tokens.zIndex.above,
    paddingHorizontal: tokens.spacing.sm,
    paddingVertical: tokens.spacing.xs,
    borderRadius: tokens.radius.sm,
    color: tokens.color.inverse,
    backgroundColor: tokens.color.overlay,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  resultFooter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.spacing.md,
    padding: tokens.spacing.md,
  },
  resultSummary: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  resultName: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  resultMeta: {
    color: tokens.color.textMuted,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  exportHistoryCardSection: {
    width: "100%",
    padding: tokens.spacing.xxl,
    gap: tokens.spacing.xl,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.xl,
    backgroundColor: tokens.color.surface,
    ...tokens.shadow.card,
  },
  exportHistoryHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: tokens.spacing.lg,
  },
  exportHistoryRefreshStatus: {
    minHeight: imageToolsTokens.size.iconButton,
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.sm,
  },
  exportHistoryStatusText: {
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.medium,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  exportHistoryLoading: {
    gap: tokens.spacing.lg,
  },
  exportHistoryLoadingCopy: {
    minHeight: imageToolsTokens.size.iconButton,
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing.sm,
  },
  exportHistoryGrid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: tokens.spacing.lg,
  },
  exportHistoryCard: {
    flexGrow: 0,
    overflow: "hidden",
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surface,
  },
  exportHistoryCardMobile: {
    flexBasis: imageToolsTokens.size.exportHistoryCardMobile,
    maxWidth: imageToolsTokens.size.exportHistoryCardMobile,
  },
  exportHistoryCardTablet: {
    flexBasis: imageToolsTokens.size.exportHistoryCardTablet,
    maxWidth: imageToolsTokens.size.exportHistoryCardTablet,
  },
  exportHistoryCardDesktop: {
    flexBasis: imageToolsTokens.size.exportHistoryCardDesktop,
    maxWidth: imageToolsTokens.size.exportHistoryCardDesktop,
  },
  exportHistoryCardHovered: {
    borderColor: tokens.color.accentDark,
  },
  exportHistoryCardPressed: {
    transform: [{ scale: imageToolsTokens.motion.pressScale }],
  },
  exportHistoryImage: {
    width: "100%",
    aspectRatio: imageToolsTokens.size.exportHistoryAspectRatio,
    backgroundColor: tokens.color.surfaceMuted,
  },
  exportHistoryUnavailable: {
    width: "100%",
    aspectRatio: imageToolsTokens.size.exportHistoryAspectRatio,
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacing.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  exportHistoryUnavailableText: {
    color: tokens.color.textMuted,
    fontFamily: tokens.font.medium,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
    textAlign: "center",
  },
  exportHistoryCardFooter: {
    gap: tokens.spacing.xs,
    padding: tokens.spacing.md,
  },
  exportHistoryCardTitle: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
  },
  exportHistoryCardDate: {
    color: tokens.color.textMuted,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.xs,
    lineHeight: tokens.lineHeight.xs,
  },
  exportHistorySkeleton: {
    aspectRatio: imageToolsTokens.size.exportHistoryAspectRatio,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  exportHistoryEmpty: {
    minHeight: tokens.spacing.massive + tokens.spacing.massive,
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacing.sm,
    padding: tokens.spacing.xxl,
    borderWidth: tokens.borderWidth.thin,
    borderColor: tokens.color.border,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.color.surfaceMuted,
  },
  exportHistoryEmptyTitle: {
    color: tokens.color.textPrimary,
    fontFamily: tokens.font.semibold,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
    textAlign: "center",
  },
  exportHistoryEmptyText: {
    maxWidth: imageToolsTokens.size.dialogMaxWidth,
    color: tokens.color.textSecondary,
    fontFamily: tokens.font.regular,
    fontSize: tokens.fontSize.sm,
    lineHeight: tokens.lineHeight.sm,
    textAlign: "center",
  },
  exportHistoryActions: {
    alignItems: "center",
  },
});
